export const student = {
  id: 'student',
  name: 'Student & Academic',
  sectionOrder: ['education', 'projects', 'experience', 'skills', 'extracurricular'],
  defaultLayout: 'single-column',
  recommendedTemplates: ['campus-placement', 'harvard-classic'],
  components: {
    experience: 'experience-classic',
    skills: 'skills-simple-list',
    header: 'header-classic'
  }
};
export default student;
